import type { Form } from 'payments-lib-types';
import type { FC } from 'react';
import { FormGroup } from '@/components/form/groups/FormGroup';
import { Input } from '@/components/form/Input';
import { required, type ValidatorMessage } from '@/helpers/validators';
import type { OfUnion } from '@/types/common';
import type { MethodField } from '../helpers';

export type FieldTextProps =
  | OfUnion<MethodField>[Form.MethodFieldType.CashoutCryptoAddress]
  | OfUnion<MethodField>[Form.MethodFieldType.CardHolder]
  | OfUnion<MethodField>[Form.MethodFieldType.Text];

export interface SpecificTypeParams {
  validatorWarning?: (value: string) => void | ValidatorMessage;
}

export const FieldText: FC<FieldTextProps & SpecificTypeParams> = ({
  fieldName,
  label,
  placeholder,
  proposedValue,
  activeThemeMode,
  validatorWarning,
}) => (
  <FormGroup mode={activeThemeMode} title={placeholder || label || fieldName}>
    <Input
      initialValue={proposedValue}
      mode={activeThemeMode}
      name={fieldName}
      placeholder={placeholder || label || fieldName}
      validate={required}
      validatorWarning={validatorWarning}
    />
  </FormGroup>
);
